import { Avatar, DatePicker, Select, Spin } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { Skeleton } from 'antd';
import { getBusinessByMarchandId } from "../../modules/developer/services/developerApi";
import { useQuery } from "react-query";
import { getCountryMethods } from "../../modules/transactions/services/transactionApi";
import defaultLogo from "../../assets/images/defaultLogo.jpg";
import dayjs from "dayjs";
import "./businessFilter.css";
import CardImageItem from "../../common/image/cardImage.js"

const BusinessFilter = ({ onFilter, isLoadingMetric, isErrorMetric, errorMetric }) => {

  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const [selectedYear, setSelectedYear] = useState("");

  const authUser =JSON.parse(sessionStorage.getItem("authUser"));
  const merchandId = authUser?.user?.id || authUser?.user?.merchantId;

  const { data: businessList, isLoading, isError } = useQuery(
    ["business", merchandId],
    () => getBusinessByMarchandId(merchandId),
    { enabled: !!merchandId }
  );

  const { data: countryList } = useQuery("countryMethods", getCountryMethods);

  useEffect(() => {
    if (businessList?.length > 0 && countryList?.length > 1) {
      const storedBusinessId = sessionStorage.getItem("selectedBusinessId");
      const storedYear = sessionStorage.getItem("selectedBusinessYear");

      const foundBusiness = businessList.find((b) => b.id.toString() === storedBusinessId);
      const fallbackBusiness = { id: "all", businessName: "Tous les business" };

      setSelectedBusiness(foundBusiness || fallbackBusiness);
      setSelectedYear(storedYear || dayjs().year().toString());
    }
  }, [businessList, countryList]);

  useEffect(() => {
    if (selectedBusiness && selectedYear && typeof onFilter === "function") {
      onFilter({ business: selectedBusiness, year: selectedYear });

      sessionStorage.setItem("selectedBusinessId", selectedBusiness.id);
      sessionStorage.setItem("selectedBusinessYear", selectedYear);
    }
  }, [selectedBusiness, selectedYear]);

  const handleBusinessChange = (id) => {
    if (id === "all") {
      setSelectedBusiness({ id: "all", businessName: "Tous les business" });
    } else {
      const selected = businessList?.find((b) => b.id === id);
      if (selected) setSelectedBusiness(selected);
    }
  };

  const sortedBusinessList = businessList
    ?.slice()
    .sort((a, b) => a.businessName.localeCompare(b.businessName));

  const selectOptions = [
    {
      value: "all",
      label: (
        <div className="bus-select-option">
          <img src={defaultLogo} alt="tous" className="bus-option-logo" />
          Tous les business
        </div>
      ),
    },
    ...(sortedBusinessList?.map((opt) => ({
      value: opt?.id ?? `fallback-${opt.businessName}`,
      label: (
        <div className="bus-select-option">
          <div className="d-flex align-items-center">
            <Avatar size={28} style={{ marginRight: 10 }}>
              <CardImageItem fileName={opt?.logo} token={authUser?.token} />
            </Avatar>
            {opt?.businessName}
          </div>          
        </div>
      ),
    })) || []),
  ];

  return (
    <div className="bus-filter-container">
      {
        isLoading && (
          <Skeleton.Input
            active
            size="default"
            style={{ width: 250 }}
          />
        )
      }
      {
        !isLoading && (
          <Select
            value={selectedBusiness?.id}
            onChange={handleBusinessChange}
            className="bus-select"
            placeholder="Choisir un business"
            suffixIcon={isLoading ? <Spin size="small" /> : <DownOutlined />}
            loading={isLoading}
            options={isError ? [{ value: "", label: "Erreur de chargement" }] : selectOptions}
          />
        )
      }

      {/* <DatePicker
        disabled={!selectedBusiness}
        value={selectedYear ? dayjs(selectedYear, "YYYY") : null}
        onChange={(date, dateString) => {
          setSelectedYear(dateString);
        }}
        picker="year"
        placeholder="Choisir une année"
        className="bus-year-picker"
        disabledDate={(current) => current && current > dayjs().endOf("year")}
      /> */}

      {isLoadingMetric && (
        <div className="bus-metric-loading">
          <Spin size="small" />
          <span>Chargement en cours...</span>
        </div>
      )}

      {isErrorMetric && (
        <div className="bus-metric-error">
          Erreur métriques :
          <span>
            {errorMetric?.response?.message || errorMetric?.message || "Erreur chargement API"}
          </span>
        </div>
      )}
    </div>
  );
};

export default BusinessFilter;
